import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';

//Styles
import cs from '../../../components/commonStyle.css';
import s from './ViewInformationRecords.css';

const ViewTableInformation = ({ icon, title, children }) => {
    return (
        <div className={cx(cs.spaceBottom4, s.border, s.radius1)}>
            <div className={cx(cs.displayFlex, cs.gap4, s.p16, s.grayBg, s.radiusTopLeft, s.radiusTopRight, cs.alignCenter, 'viewInformationRecordsDarModeBG')}>
                {icon}
                <h3 className={cx(s.titleText, cs.fontWeightMedium)}>{title}</h3>
            </div>
            <div>
                {children}
            </div>
        </div>
    )
}

ViewTableInformation.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired
}

export default injectIntl(withStyles(cs, s)(ViewTableInformation));